import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  gap: 8px;
  width: auto;
  height: 32px;
  padding: 0 8px 0 4px;
  margin: 3px 0;
  background: #fff;
  border-radius: 32px;
  border: 1px solid #d0d6dd;
  cursor: pointer;
  transition: all 250ms ease 0s;

  &:hover {
    border-color: #4b61dd;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
`;

export const Icon = styled.span`
  display: block;
  width: 24px;
  height: 24px;
  background: #d1e1ff;
  border-radius: 24px;
`;

export const Text = styled.span`
  display: block;
  line-height: 1.715;
  font-weight: 400;
  font-size: 14px;
  color: #232933;
`;

export const Badge = styled.span`
  display: flex;
  align-items: center;
  border-radius: 16px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  height: 16px;
  color: #fff;
  background: #3b82f6;
  padding: 2px 4px;
`;
